export const radiusFull = '999em';
export const radiusSmall = '0.125rem';
export const borderWidthLarge = '0.1875rem';
export const borderWidthMedium = '0.125rem';
export const borderWidthSmall = '0.0625rem';
export const colorBackgroundDanger = '#f5e9e8';
export const colorBackgroundPrimary = '#ffffff';
export const colorBackgroundSecondary = '#f4f4f5';
export const colorBackgroundSideNav = '#021c6b';
export const colorBackgroundSuccess = '#ddefe6';
export const colorBackgroundSurface = '#ffffff';
export const colorBackgroundTertiary = '#e4e6e7';
export const colorBackgroundTopNav = '#1f3987';
export const colorBackgroundWarning = '#fbede7';
export const colorBorderDanger = '#b4362f';
export const colorBorderDisabled = '#f4f4f5';
export const colorBorderPrimary = '#e4e6e7';
export const colorBorderSuccess = '#0b6b3d';
export const colorBorderWarning = '#f45e1e';
export const colorBrandDefault = '#0072ec';
export const colorBrandActive =
  'linear-gradient(0deg, rgba(9, 21, 33, 0.4), rgba(9, 21, 33, 0.4)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)';
export const colorBrandHover =
  'linear-gradient(0deg, rgba(9, 21, 33, 0.2), rgba(9, 21, 33, 0.2)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)';
export const colorBrandGradient =
  'linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)';
export const colorDataVizDangerFill = '#e3837d';
export const colorDataVizDangerHover = '#b4362f';
export const colorDataVizDangerLine = '#d44037';
export const colorDataVizNeutralFill = '#d1d3d6';
export const colorDataVizNeutralHover = '#898e94';
export const colorDataVizPrimaryFill = '#7785db';
export const colorDataVizPrimaryFillAlt = '#c7ccf0';
export const colorDataVizPrimaryHover = '#3442bc';
export const colorDataVizPrimaryLine = '#3142c8';
export const colorDataVizSecondaryFill = '#62a9f4';
export const colorDataVizSecondaryFillAlt = '#c9e1fb';
export const colorDataVizSecondaryHover = '#005cbe';
export const colorDataVizSecondaryLine = '#0072ec';
export const colorDataVizTertiaryFill = '#b16fed';
export const colorDataVizTertiaryFillAlt = '#ddd0f3';
export const colorDataVizTertiaryHover = '#8110dc';
export const colorDataVizTertiaryLine = '#8c18e2';
export const colorDataVizWarningFill = '#ff9365';
export const colorDataVizWarningHover = '#f45e1e';
export const colorDataVizWarningLine = '#ff6422';
export const colorPaletteBlack = '#091521';
export const colorPaletteWhite = '#ffffff';
export const colorPaletteBlue50 = '#ecf4fe';
export const colorPaletteBlue100 = '#c9e1fb';
export const colorPaletteBlue200 = '#95c5f8';
export const colorPaletteBlue300 = '#62a9f4';
export const colorPaletteBlue400 = '#308df1';
export const colorPaletteBlue500 = '#0072ec';
export const colorPaletteBlue600 = '#005cbe';
export const colorPaletteBlue700 = '#00458e';
export const colorPaletteBlue800 = '#003772';
export const colorPaletteBlue900 = '#002956';
export const colorPaletteBrown50 = '#faf0e7';
export const colorPaletteBrown100 = '#ead9ce';
export const colorPaletteBrown200 = '#d8c1b2';
export const colorPaletteBrown300 = '#c4a794';
export const colorPaletteBrown400 = '#b3917b';
export const colorPaletteBrown500 = '#a27c62';
export const colorPaletteBrown600 = '#95715a';
export const colorPaletteBrown700 = '#84634f';
export const colorPaletteBrown800 = '#755646';
export const colorPaletteBrown900 = '#64473a';
export const colorPaletteGreen50 = '#ddefe6';
export const colorPaletteGreen100 = '#c3e1d2';
export const colorPaletteGreen200 = '#93c9ae';
export const colorPaletteGreen300 = '#62b08b';
export const colorPaletteGreen400 = '#329867';
export const colorPaletteGreen500 = '#0e864c';
export const colorPaletteGreen600 = '#0b6b3d';
export const colorPaletteGreen700 = '#095731';
export const colorPaletteGreen800 = '#074326';
export const colorPaletteGreen900 = '#06361e';
export const colorPaletteGrey50 = '#fafafb';
export const colorPaletteGrey100 = '#f4f4f5';
export const colorPaletteGrey200 = '#e4e6e7';
export const colorPaletteGrey300 = '#d1d3d6';
export const colorPaletteGrey400 = '#a9adb1';
export const colorPaletteGrey500 = '#898e94';
export const colorPaletteGrey600 = '#697078';
export const colorPaletteGrey700 = '#49515a';
export const colorPaletteGrey800 = '#2a343f';
export const colorPaletteGrey900 = '#091521';
export const colorPaletteIndigo50 = '#e9eafa';
export const colorPaletteIndigo100 = '#c7ccf0';
export const colorPaletteIndigo200 = '#a5aee8';
export const colorPaletteIndigo300 = '#7785db';
export const colorPaletteIndigo400 = '#5c6cd6';
export const colorPaletteIndigo500 = '#3142c8';
export const colorPaletteIndigo600 = '#3442bc';
export const colorPaletteIndigo700 = '#2e39ad';
export const colorPaletteIndigo800 = '#232b9c';
export const colorPaletteIndigo900 = '#16158d';
export const colorPaletteOrange50 = '#fbede7';
export const colorPaletteOrange100 = '#ffd0bc';
export const colorPaletteOrange200 = '#ffb291';
export const colorPaletteOrange300 = '#ff9365';
export const colorPaletteOrange400 = '#ff7b43';
export const colorPaletteOrange500 = '#ff6422';
export const colorPaletteOrange600 = '#f45e1e';
export const colorPaletteOrange700 = '#e65719';
export const colorPaletteOrange800 = '#d85015';
export const colorPaletteOrange900 = '#bf420c';
export const colorPalettePink50 = '#fbe5ee';
export const colorPalettePink100 = '#f6bed6';
export const colorPalettePink200 = '#f194ba';
export const colorPalettePink300 = '#ed6a9f';
export const colorPalettePink400 = '#ea4c89';
export const colorPalettePink500 = '#e83274';
export const colorPalettePink600 = '#d72f70';
export const colorPalettePink700 = '#c02c69';
export const colorPalettePink800 = '#aa2964';
export const colorPalettePink900 = '#852259';
export const colorPalettePurple50 = '#f2e7fc';
export const colorPalettePurple100 = '#ddd0f3';
export const colorPalettePurple200 = '#c79bf2';
export const colorPalettePurple300 = '#b16fed';
export const colorPalettePurple400 = '#9e4ae8';
export const colorPalettePurple500 = '#8c18e2';
export const colorPalettePurple600 = '#8110dc';
export const colorPalettePurple700 = '#7300d3';
export const colorPalettePurple800 = '#6500ce';
export const colorPalettePurple900 = '#4e00c6';
export const colorPaletteRed50 = '#f5e9e8';
export const colorPaletteRed100 = '#f4cfcd';
export const colorPaletteRed200 = '#eca9a5';
export const colorPaletteRed300 = '#e3837d';
export const colorPaletteRed400 = '#da5d55';
export const colorPaletteRed500 = '#d44037';
export const colorPaletteRed600 = '#b4362f';
export const colorPaletteRed700 = '#942d27';
export const colorPaletteRed800 = '#75231e';
export const colorPaletteRed900 = '#551a16';
export const colorPaletteYellow50 = '#fefae7';
export const colorPaletteYellow100 = '#fbf1c4';
export const colorPaletteYellow200 = '#f8e99f';
export const colorPaletteYellow300 = '#f4e07b';
export const colorPaletteYellow400 = '#f0d961';
export const colorPaletteYellow500 = '#ecd348';
export const colorPaletteYellow600 = '#dcc243';
export const colorPaletteYellow700 = '#c8ac3d';
export const colorPaletteYellow800 = '#b39638';
export const colorPaletteYellow900 = '#90722f';
export const colorPrimaryDefault = '#3142c8';
export const colorPrimaryActive = '#16158d';
export const colorPrimaryHover = '#2e39ad';
export const colorTextContrast = '#ffffff';
export const colorTextDanger = '#b4362f';
export const colorTextDisabled = '#a9adb1';
export const colorTextPrimary = '#091521';
export const colorTextSecondary = '#49515a';
export const colorTextSuccess = '#0b6b3d';
export const colorTextTertiary = '#898e94';
export const colorTextWarning = '#f45e1e';
export const shadowLarge =
  '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 6px 14px rgba(61, 58, 180, 0.15)';
export const shadowMedium =
  '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 4px 5px rgba(61, 58, 180, 0.15)';
export const shadowSmall =
  '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 1px 2px rgba(61, 58, 180, 0.4)';
export const zIndexDialog = 6000;
export const zIndexDropdown = 7000;
export const zIndexModal = 9000;
export const zIndexOverlay = 8000;
export const zIndexPopover = 5000;
export const zIndexSticky = 100;
export const zIndexToast = 10000;
export const zIndexTooltip = 6000;
export const sizeLarge = '87.5rem';
export const sizeMedium = '80rem';
export const sizeSmall = '60rem';
export const sizeXLarge = '120rem';
export const sizeXSmall = '40.625rem';
export const spaceMedium = '1rem';
export const spaceSmall = '0.5rem';
export const spaceLarge = '1.5rem';
export const spaceXLarge = '2rem';
export const spaceXSmall = '0.25rem';
export const fontFamilyMono = '"Fira Mono", Courier, monospace';
export const fontFamilyText =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
export const fontSizeLarge = '1.25rem';
export const fontSizeMedium = '1rem';
export const fontSizeSmall = '0.875rem';
export const fontSizeXLarge = '1.5rem';
export const fontSizeXSmall = '0.75rem';
export const fontSizeXxLarge = '2rem';
export const fontWeightBold = 700;
export const fontWeightRegular = 400;
export const fontWeightSemibold = 600;
export const letterSpacingLarge = '0em';
export const letterSpacingMedium = '-0.01em';
export const letterSpacingSmall = '-0.02em';
export const letterSpacingXSmall = '-0.03em';
export const lineHeightLarge = '1.875rem';
export const lineHeightMedium = '1.5rem';
export const lineHeightSmall = '1.25rem';
export const lineHeightXLarge = '2rem';
export const lineHeightXSmall = '1.125rem';
export const lineHeightXxLarge = '2.625rem';
export const radius = {
  full: '999em',
  small: '0.125rem',
};

export const borderWidth = {
  large: '0.1875rem',
  medium: '0.125rem',
  small: '0.0625rem',
};

export const color = {
  background: {
    danger: '#f5e9e8',
    primary: '#ffffff',
    secondary: '#f4f4f5',
    sideNav: '#021c6b',
    success: '#ddefe6',
    surface: '#ffffff',
    tertiary: '#e4e6e7',
    topNav: '#1f3987',
    warning: '#fbede7',
  },
  border: {
    danger: '#b4362f',
    disabled: '#f4f4f5',
    primary: '#e4e6e7',
    success: '#0b6b3d',
    warning: '#f45e1e',
  },
  brand: {
    default: '#0072ec',
    active:
      'linear-gradient(0deg, rgba(9, 21, 33, 0.4), rgba(9, 21, 33, 0.4)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)',
    hover:
      'linear-gradient(0deg, rgba(9, 21, 33, 0.2), rgba(9, 21, 33, 0.2)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)',
    gradient: 'linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)',
  },
  dataViz: {
    dangerFill: '#e3837d',
    dangerHover: '#b4362f',
    dangerLine: '#d44037',
    neutralFill: '#d1d3d6',
    neutralHover: '#898e94',
    primaryFill: '#7785db',
    primaryFillAlt: '#c7ccf0',
    primaryHover: '#3442bc',
    primaryLine: '#3142c8',
    secondaryFill: '#62a9f4',
    secondaryFillAlt: '#c9e1fb',
    secondaryHover: '#005cbe',
    secondaryLine: '#0072ec',
    tertiaryFill: '#b16fed',
    tertiaryFillAlt: '#ddd0f3',
    tertiaryHover: '#8110dc',
    tertiaryLine: '#8c18e2',
    warningFill: '#ff9365',
    warningHover: '#f45e1e',
    warningLine: '#ff6422',
  },
  palette: {
    black: '#091521',
    white: '#ffffff',
    blue: {
      '50': '#ecf4fe',
      '100': '#c9e1fb',
      '200': '#95c5f8',
      '300': '#62a9f4',
      '400': '#308df1',
      '500': '#0072ec',
      '600': '#005cbe',
      '700': '#00458e',
      '800': '#003772',
      '900': '#002956',
    },
    brown: {
      '50': '#faf0e7',
      '100': '#ead9ce',
      '200': '#d8c1b2',
      '300': '#c4a794',
      '400': '#b3917b',
      '500': '#a27c62',
      '600': '#95715a',
      '700': '#84634f',
      '800': '#755646',
      '900': '#64473a',
    },
    green: {
      '50': '#ddefe6',
      '100': '#c3e1d2',
      '200': '#93c9ae',
      '300': '#62b08b',
      '400': '#329867',
      '500': '#0e864c',
      '600': '#0b6b3d',
      '700': '#095731',
      '800': '#074326',
      '900': '#06361e',
    },
    grey: {
      '50': '#fafafb',
      '100': '#f4f4f5',
      '200': '#e4e6e7',
      '300': '#d1d3d6',
      '400': '#a9adb1',
      '500': '#898e94',
      '600': '#697078',
      '700': '#49515a',
      '800': '#2a343f',
      '900': '#091521',
    },
    indigo: {
      '50': '#e9eafa',
      '100': '#c7ccf0',
      '200': '#a5aee8',
      '300': '#7785db',
      '400': '#5c6cd6',
      '500': '#3142c8',
      '600': '#3442bc',
      '700': '#2e39ad',
      '800': '#232b9c',
      '900': '#16158d',
    },
    orange: {
      '50': '#fbede7',
      '100': '#ffd0bc',
      '200': '#ffb291',
      '300': '#ff9365',
      '400': '#ff7b43',
      '500': '#ff6422',
      '600': '#f45e1e',
      '700': '#e65719',
      '800': '#d85015',
      '900': '#bf420c',
    },
    pink: {
      '50': '#fbe5ee',
      '100': '#f6bed6',
      '200': '#f194ba',
      '300': '#ed6a9f',
      '400': '#ea4c89',
      '500': '#e83274',
      '600': '#d72f70',
      '700': '#c02c69',
      '800': '#aa2964',
      '900': '#852259',
    },
    purple: {
      '50': '#f2e7fc',
      '100': '#ddd0f3',
      '200': '#c79bf2',
      '300': '#b16fed',
      '400': '#9e4ae8',
      '500': '#8c18e2',
      '600': '#8110dc',
      '700': '#7300d3',
      '800': '#6500ce',
      '900': '#4e00c6',
    },
    red: {
      '50': '#f5e9e8',
      '100': '#f4cfcd',
      '200': '#eca9a5',
      '300': '#e3837d',
      '400': '#da5d55',
      '500': '#d44037',
      '600': '#b4362f',
      '700': '#942d27',
      '800': '#75231e',
      '900': '#551a16',
    },
    yellow: {
      '50': '#fefae7',
      '100': '#fbf1c4',
      '200': '#f8e99f',
      '300': '#f4e07b',
      '400': '#f0d961',
      '500': '#ecd348',
      '600': '#dcc243',
      '700': '#c8ac3d',
      '800': '#b39638',
      '900': '#90722f',
    },
  },
  primary: {
    default: '#3142c8',
    active: '#16158d',
    hover: '#2e39ad',
  },
  text: {
    contrast: '#ffffff',
    danger: '#b4362f',
    disabled: '#a9adb1',
    primary: '#091521',
    secondary: '#49515a',
    success: '#0b6b3d',
    tertiary: '#898e94',
    warning: '#f45e1e',
  },
};

export const shadow = {
  large: '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 6px 14px rgba(61, 58, 180, 0.15)',
  medium: '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 4px 5px rgba(61, 58, 180, 0.15)',
  small: '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 1px 2px rgba(61, 58, 180, 0.4)',
};

export const zIndex = {
  dialog: 6000,
  dropdown: 7000,
  modal: 9000,
  overlay: 8000,
  popover: 5000,
  sticky: 100,
  toast: 10000,
  tooltip: 6000,
};

export const size = {
  large: '87.5rem',
  medium: '80rem',
  small: '60rem',
  'x-large': '120rem',
  'x-small': '40.625rem',
};

export const space = {
  medium: '1rem',
  small: '0.5rem',
  large: '1.5rem',
  'x-large': '2rem',
  'x-small': '0.25rem',
};

export const fontFamily = {
  mono: '"Fira Mono", Courier, monospace',
  text: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
};

export const fontSize = {
  large: '1.25rem',
  medium: '1rem',
  small: '0.875rem',
  'x-large': '1.5rem',
  'x-small': '0.75rem',
  'xx-large': '2rem',
};

export const fontWeight = {
  bold: 700,
  regular: 400,
  semibold: 600,
};

export const letterSpacing = {
  large: '0em',
  medium: '-0.01em',
  small: '-0.02em',
  'x-small': '-0.03em',
};

export const lineHeight = {
  large: '1.875rem',
  medium: '1.5rem',
  small: '1.25rem',
  'x-large': '2rem',
  'x-small': '1.125rem',
  'xx-large': '2.625rem',
};

export const tokens = [
  {
    value: '999em',
    name: 'radiusFull',
    attributes: {
      category: 'radius',
      type: 'full',
    },
    path: ['radius', 'full'],
  },
  {
    value: '0.125rem',
    name: 'radiusSmall',
    attributes: {
      category: 'radius',
      type: 'small',
    },
    path: ['radius', 'small'],
  },
  {
    value: '0.1875rem',
    name: 'borderWidthLarge',
    attributes: {
      category: 'borderWidth',
      type: 'large',
    },
    path: ['borderWidth', 'large'],
  },
  {
    value: '0.125rem',
    name: 'borderWidthMedium',
    attributes: {
      category: 'borderWidth',
      type: 'medium',
    },
    path: ['borderWidth', 'medium'],
  },
  {
    value: '0.0625rem',
    name: 'borderWidthSmall',
    attributes: {
      category: 'borderWidth',
      type: 'small',
    },
    path: ['borderWidth', 'small'],
  },
  {
    value: '#f5e9e8',
    name: 'colorBackgroundDanger',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'danger',
    },
    path: ['color', 'background', 'danger'],
  },
  {
    value: '#ffffff',
    name: 'colorBackgroundPrimary',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'primary',
    },
    path: ['color', 'background', 'primary'],
  },
  {
    value: '#f4f4f5',
    name: 'colorBackgroundSecondary',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'secondary',
    },
    path: ['color', 'background', 'secondary'],
  },
  {
    value: '#021c6b',
    name: 'colorBackgroundSideNav',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'sideNav',
    },
    path: ['color', 'background', 'sideNav'],
  },
  {
    value: '#ddefe6',
    name: 'colorBackgroundSuccess',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'success',
    },
    path: ['color', 'background', 'success'],
  },
  {
    value: '#ffffff',
    name: 'colorBackgroundSurface',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'surface',
    },
    path: ['color', 'background', 'surface'],
  },
  {
    value: '#e4e6e7',
    name: 'colorBackgroundTertiary',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'tertiary',
    },
    path: ['color', 'background', 'tertiary'],
  },
  {
    value: '#1f3987',
    name: 'colorBackgroundTopNav',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'topNav',
    },
    path: ['color', 'background', 'topNav'],
  },
  {
    value: '#fbede7',
    name: 'colorBackgroundWarning',
    attributes: {
      category: 'color',
      type: 'background',
      item: 'warning',
    },
    path: ['color', 'background', 'warning'],
  },
  {
    value: '#b4362f',
    name: 'colorBorderDanger',
    attributes: {
      category: 'color',
      type: 'border',
      item: 'danger',
    },
    path: ['color', 'border', 'danger'],
  },
  {
    value: '#f4f4f5',
    name: 'colorBorderDisabled',
    attributes: {
      category: 'color',
      type: 'border',
      item: 'disabled',
    },
    path: ['color', 'border', 'disabled'],
  },
  {
    value: '#e4e6e7',
    name: 'colorBorderPrimary',
    attributes: {
      category: 'color',
      type: 'border',
      item: 'primary',
    },
    path: ['color', 'border', 'primary'],
  },
  {
    value: '#0b6b3d',
    name: 'colorBorderSuccess',
    attributes: {
      category: 'color',
      type: 'border',
      item: 'success',
    },
    path: ['color', 'border', 'success'],
  },
  {
    value: '#f45e1e',
    name: 'colorBorderWarning',
    attributes: {
      category: 'color',
      type: 'border',
      item: 'warning',
    },
    path: ['color', 'border', 'warning'],
  },
  {
    value: '#0072ec',
    name: 'colorBrandDefault',
    attributes: {
      category: 'color',
      type: 'brand',
      item: 'default',
    },
    path: ['color', 'brand', 'default'],
  },
  {
    value:
      'linear-gradient(0deg, rgba(9, 21, 33, 0.4), rgba(9, 21, 33, 0.4)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)',
    name: 'colorBrandActive',
    attributes: {
      category: 'color',
      type: 'brand',
      item: 'active',
    },
    path: ['color', 'brand', 'active'],
  },
  {
    value:
      'linear-gradient(0deg, rgba(9, 21, 33, 0.2), rgba(9, 21, 33, 0.2)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)',
    name: 'colorBrandHover',
    attributes: {
      category: 'color',
      type: 'brand',
      item: 'hover',
    },
    path: ['color', 'brand', 'hover'],
  },
  {
    value: 'linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)',
    name: 'colorBrandGradient',
    attributes: {
      category: 'color',
      type: 'brand',
      item: 'gradient',
    },
    path: ['color', 'brand', 'gradient'],
  },
  {
    value: '#e3837d',
    name: 'colorDataVizDangerFill',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'dangerFill',
    },
    path: ['color', 'dataViz', 'dangerFill'],
  },
  {
    value: '#b4362f',
    name: 'colorDataVizDangerHover',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'dangerHover',
    },
    path: ['color', 'dataViz', 'dangerHover'],
  },
  {
    value: '#d44037',
    name: 'colorDataVizDangerLine',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'dangerLine',
    },
    path: ['color', 'dataViz', 'dangerLine'],
  },
  {
    value: '#d1d3d6',
    name: 'colorDataVizNeutralFill',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'neutralFill',
    },
    path: ['color', 'dataViz', 'neutralFill'],
  },
  {
    value: '#898e94',
    name: 'colorDataVizNeutralHover',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'neutralHover',
    },
    path: ['color', 'dataViz', 'neutralHover'],
  },
  {
    value: '#7785db',
    name: 'colorDataVizPrimaryFill',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'primaryFill',
    },
    path: ['color', 'dataViz', 'primaryFill'],
  },
  {
    value: '#c7ccf0',
    name: 'colorDataVizPrimaryFillAlt',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'primaryFillAlt',
    },
    path: ['color', 'dataViz', 'primaryFillAlt'],
  },
  {
    value: '#3442bc',
    name: 'colorDataVizPrimaryHover',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'primaryHover',
    },
    path: ['color', 'dataViz', 'primaryHover'],
  },
  {
    value: '#3142c8',
    name: 'colorDataVizPrimaryLine',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'primaryLine',
    },
    path: ['color', 'dataViz', 'primaryLine'],
  },
  {
    value: '#62a9f4',
    name: 'colorDataVizSecondaryFill',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'secondaryFill',
    },
    path: ['color', 'dataViz', 'secondaryFill'],
  },
  {
    value: '#c9e1fb',
    name: 'colorDataVizSecondaryFillAlt',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'secondaryFillAlt',
    },
    path: ['color', 'dataViz', 'secondaryFillAlt'],
  },
  {
    value: '#005cbe',
    name: 'colorDataVizSecondaryHover',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'secondaryHover',
    },
    path: ['color', 'dataViz', 'secondaryHover'],
  },
  {
    value: '#0072ec',
    name: 'colorDataVizSecondaryLine',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'secondaryLine',
    },
    path: ['color', 'dataViz', 'secondaryLine'],
  },
  {
    value: '#b16fed',
    name: 'colorDataVizTertiaryFill',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'tertiaryFill',
    },
    path: ['color', 'dataViz', 'tertiaryFill'],
  },
  {
    value: '#ddd0f3',
    name: 'colorDataVizTertiaryFillAlt',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'tertiaryFillAlt',
    },
    path: ['color', 'dataViz', 'tertiaryFillAlt'],
  },
  {
    value: '#8110dc',
    name: 'colorDataVizTertiaryHover',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'tertiaryHover',
    },
    path: ['color', 'dataViz', 'tertiaryHover'],
  },
  {
    value: '#8c18e2',
    name: 'colorDataVizTertiaryLine',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'tertiaryLine',
    },
    path: ['color', 'dataViz', 'tertiaryLine'],
  },
  {
    value: '#ff9365',
    name: 'colorDataVizWarningFill',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'warningFill',
    },
    path: ['color', 'dataViz', 'warningFill'],
  },
  {
    value: '#f45e1e',
    name: 'colorDataVizWarningHover',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'warningHover',
    },
    path: ['color', 'dataViz', 'warningHover'],
  },
  {
    value: '#ff6422',
    name: 'colorDataVizWarningLine',
    attributes: {
      category: 'color',
      type: 'dataViz',
      item: 'warningLine',
    },
    path: ['color', 'dataViz', 'warningLine'],
  },
  {
    value: '#091521',
    name: 'colorPaletteBlack',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'black',
    },
    path: ['color', 'palette', 'black'],
  },
  {
    value: '#ffffff',
    name: 'colorPaletteWhite',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'white',
    },
    path: ['color', 'palette', 'white'],
  },
  {
    value: '#ecf4fe',
    name: 'colorPaletteBlue50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '50',
    },
    path: ['color', 'palette', 'blue', '50'],
  },
  {
    value: '#c9e1fb',
    name: 'colorPaletteBlue100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '100',
    },
    path: ['color', 'palette', 'blue', '100'],
  },
  {
    value: '#95c5f8',
    name: 'colorPaletteBlue200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '200',
    },
    path: ['color', 'palette', 'blue', '200'],
  },
  {
    value: '#62a9f4',
    name: 'colorPaletteBlue300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '300',
    },
    path: ['color', 'palette', 'blue', '300'],
  },
  {
    value: '#308df1',
    name: 'colorPaletteBlue400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '400',
    },
    path: ['color', 'palette', 'blue', '400'],
  },
  {
    value: '#0072ec',
    name: 'colorPaletteBlue500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '500',
    },
    path: ['color', 'palette', 'blue', '500'],
  },
  {
    value: '#005cbe',
    name: 'colorPaletteBlue600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '600',
    },
    path: ['color', 'palette', 'blue', '600'],
  },
  {
    value: '#00458e',
    name: 'colorPaletteBlue700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '700',
    },
    path: ['color', 'palette', 'blue', '700'],
  },
  {
    value: '#003772',
    name: 'colorPaletteBlue800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '800',
    },
    path: ['color', 'palette', 'blue', '800'],
  },
  {
    value: '#002956',
    name: 'colorPaletteBlue900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'blue',
      subitem: '900',
    },
    path: ['color', 'palette', 'blue', '900'],
  },
  {
    value: '#faf0e7',
    name: 'colorPaletteBrown50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '50',
    },
    path: ['color', 'palette', 'brown', '50'],
  },
  {
    value: '#ead9ce',
    name: 'colorPaletteBrown100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '100',
    },
    path: ['color', 'palette', 'brown', '100'],
  },
  {
    value: '#d8c1b2',
    name: 'colorPaletteBrown200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '200',
    },
    path: ['color', 'palette', 'brown', '200'],
  },
  {
    value: '#c4a794',
    name: 'colorPaletteBrown300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '300',
    },
    path: ['color', 'palette', 'brown', '300'],
  },
  {
    value: '#b3917b',
    name: 'colorPaletteBrown400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '400',
    },
    path: ['color', 'palette', 'brown', '400'],
  },
  {
    value: '#a27c62',
    name: 'colorPaletteBrown500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '500',
    },
    path: ['color', 'palette', 'brown', '500'],
  },
  {
    value: '#95715a',
    name: 'colorPaletteBrown600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '600',
    },
    path: ['color', 'palette', 'brown', '600'],
  },
  {
    value: '#84634f',
    name: 'colorPaletteBrown700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '700',
    },
    path: ['color', 'palette', 'brown', '700'],
  },
  {
    value: '#755646',
    name: 'colorPaletteBrown800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '800',
    },
    path: ['color', 'palette', 'brown', '800'],
  },
  {
    value: '#64473a',
    name: 'colorPaletteBrown900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'brown',
      subitem: '900',
    },
    path: ['color', 'palette', 'brown', '900'],
  },
  {
    value: '#ddefe6',
    name: 'colorPaletteGreen50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '50',
    },
    path: ['color', 'palette', 'green', '50'],
  },
  {
    value: '#c3e1d2',
    name: 'colorPaletteGreen100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '100',
    },
    path: ['color', 'palette', 'green', '100'],
  },
  {
    value: '#93c9ae',
    name: 'colorPaletteGreen200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '200',
    },
    path: ['color', 'palette', 'green', '200'],
  },
  {
    value: '#62b08b',
    name: 'colorPaletteGreen300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '300',
    },
    path: ['color', 'palette', 'green', '300'],
  },
  {
    value: '#329867',
    name: 'colorPaletteGreen400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '400',
    },
    path: ['color', 'palette', 'green', '400'],
  },
  {
    value: '#0e864c',
    name: 'colorPaletteGreen500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '500',
    },
    path: ['color', 'palette', 'green', '500'],
  },
  {
    value: '#0b6b3d',
    name: 'colorPaletteGreen600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '600',
    },
    path: ['color', 'palette', 'green', '600'],
  },
  {
    value: '#095731',
    name: 'colorPaletteGreen700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '700',
    },
    path: ['color', 'palette', 'green', '700'],
  },
  {
    value: '#074326',
    name: 'colorPaletteGreen800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '800',
    },
    path: ['color', 'palette', 'green', '800'],
  },
  {
    value: '#06361e',
    name: 'colorPaletteGreen900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'green',
      subitem: '900',
    },
    path: ['color', 'palette', 'green', '900'],
  },
  {
    value: '#fafafb',
    name: 'colorPaletteGrey50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '50',
    },
    path: ['color', 'palette', 'grey', '50'],
  },
  {
    value: '#f4f4f5',
    name: 'colorPaletteGrey100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '100',
    },
    path: ['color', 'palette', 'grey', '100'],
  },
  {
    value: '#e4e6e7',
    name: 'colorPaletteGrey200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '200',
    },
    path: ['color', 'palette', 'grey', '200'],
  },
  {
    value: '#d1d3d6',
    name: 'colorPaletteGrey300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '300',
    },
    path: ['color', 'palette', 'grey', '300'],
  },
  {
    value: '#a9adb1',
    name: 'colorPaletteGrey400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '400',
    },
    path: ['color', 'palette', 'grey', '400'],
  },
  {
    value: '#898e94',
    name: 'colorPaletteGrey500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '500',
    },
    path: ['color', 'palette', 'grey', '500'],
  },
  {
    value: '#697078',
    name: 'colorPaletteGrey600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '600',
    },
    path: ['color', 'palette', 'grey', '600'],
  },
  {
    value: '#49515a',
    name: 'colorPaletteGrey700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '700',
    },
    path: ['color', 'palette', 'grey', '700'],
  },
  {
    value: '#2a343f',
    name: 'colorPaletteGrey800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '800',
    },
    path: ['color', 'palette', 'grey', '800'],
  },
  {
    value: '#091521',
    name: 'colorPaletteGrey900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'grey',
      subitem: '900',
    },
    path: ['color', 'palette', 'grey', '900'],
  },
  {
    value: '#e9eafa',
    name: 'colorPaletteIndigo50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '50',
    },
    path: ['color', 'palette', 'indigo', '50'],
  },
  {
    value: '#c7ccf0',
    name: 'colorPaletteIndigo100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '100',
    },
    path: ['color', 'palette', 'indigo', '100'],
  },
  {
    value: '#a5aee8',
    name: 'colorPaletteIndigo200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '200',
    },
    path: ['color', 'palette', 'indigo', '200'],
  },
  {
    value: '#7785db',
    name: 'colorPaletteIndigo300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '300',
    },
    path: ['color', 'palette', 'indigo', '300'],
  },
  {
    value: '#5c6cd6',
    name: 'colorPaletteIndigo400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '400',
    },
    path: ['color', 'palette', 'indigo', '400'],
  },
  {
    value: '#3142c8',
    name: 'colorPaletteIndigo500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '500',
    },
    path: ['color', 'palette', 'indigo', '500'],
  },
  {
    value: '#3442bc',
    name: 'colorPaletteIndigo600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '600',
    },
    path: ['color', 'palette', 'indigo', '600'],
  },
  {
    value: '#2e39ad',
    name: 'colorPaletteIndigo700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '700',
    },
    path: ['color', 'palette', 'indigo', '700'],
  },
  {
    value: '#232b9c',
    name: 'colorPaletteIndigo800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '800',
    },
    path: ['color', 'palette', 'indigo', '800'],
  },
  {
    value: '#16158d',
    name: 'colorPaletteIndigo900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'indigo',
      subitem: '900',
    },
    path: ['color', 'palette', 'indigo', '900'],
  },
  {
    value: '#fbede7',
    name: 'colorPaletteOrange50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '50',
    },
    path: ['color', 'palette', 'orange', '50'],
  },
  {
    value: '#ffd0bc',
    name: 'colorPaletteOrange100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '100',
    },
    path: ['color', 'palette', 'orange', '100'],
  },
  {
    value: '#ffb291',
    name: 'colorPaletteOrange200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '200',
    },
    path: ['color', 'palette', 'orange', '200'],
  },
  {
    value: '#ff9365',
    name: 'colorPaletteOrange300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '300',
    },
    path: ['color', 'palette', 'orange', '300'],
  },
  {
    value: '#ff7b43',
    name: 'colorPaletteOrange400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '400',
    },
    path: ['color', 'palette', 'orange', '400'],
  },
  {
    value: '#ff6422',
    name: 'colorPaletteOrange500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '500',
    },
    path: ['color', 'palette', 'orange', '500'],
  },
  {
    value: '#f45e1e',
    name: 'colorPaletteOrange600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '600',
    },
    path: ['color', 'palette', 'orange', '600'],
  },
  {
    value: '#e65719',
    name: 'colorPaletteOrange700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '700',
    },
    path: ['color', 'palette', 'orange', '700'],
  },
  {
    value: '#d85015',
    name: 'colorPaletteOrange800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '800',
    },
    path: ['color', 'palette', 'orange', '800'],
  },
  {
    value: '#bf420c',
    name: 'colorPaletteOrange900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'orange',
      subitem: '900',
    },
    path: ['color', 'palette', 'orange', '900'],
  },
  {
    value: '#fbe5ee',
    name: 'colorPalettePink50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '50',
    },
    path: ['color', 'palette', 'pink', '50'],
  },
  {
    value: '#f6bed6',
    name: 'colorPalettePink100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '100',
    },
    path: ['color', 'palette', 'pink', '100'],
  },
  {
    value: '#f194ba',
    name: 'colorPalettePink200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '200',
    },
    path: ['color', 'palette', 'pink', '200'],
  },
  {
    value: '#ed6a9f',
    name: 'colorPalettePink300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '300',
    },
    path: ['color', 'palette', 'pink', '300'],
  },
  {
    value: '#ea4c89',
    name: 'colorPalettePink400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '400',
    },
    path: ['color', 'palette', 'pink', '400'],
  },
  {
    value: '#e83274',
    name: 'colorPalettePink500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '500',
    },
    path: ['color', 'palette', 'pink', '500'],
  },
  {
    value: '#d72f70',
    name: 'colorPalettePink600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '600',
    },
    path: ['color', 'palette', 'pink', '600'],
  },
  {
    value: '#c02c69',
    name: 'colorPalettePink700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '700',
    },
    path: ['color', 'palette', 'pink', '700'],
  },
  {
    value: '#aa2964',
    name: 'colorPalettePink800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '800',
    },
    path: ['color', 'palette', 'pink', '800'],
  },
  {
    value: '#852259',
    name: 'colorPalettePink900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'pink',
      subitem: '900',
    },
    path: ['color', 'palette', 'pink', '900'],
  },
  {
    value: '#f2e7fc',
    name: 'colorPalettePurple50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '50',
    },
    path: ['color', 'palette', 'purple', '50'],
  },
  {
    value: '#ddd0f3',
    name: 'colorPalettePurple100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '100',
    },
    path: ['color', 'palette', 'purple', '100'],
  },
  {
    value: '#c79bf2',
    name: 'colorPalettePurple200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '200',
    },
    path: ['color', 'palette', 'purple', '200'],
  },
  {
    value: '#b16fed',
    name: 'colorPalettePurple300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '300',
    },
    path: ['color', 'palette', 'purple', '300'],
  },
  {
    value: '#9e4ae8',
    name: 'colorPalettePurple400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '400',
    },
    path: ['color', 'palette', 'purple', '400'],
  },
  {
    value: '#8c18e2',
    name: 'colorPalettePurple500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '500',
    },
    path: ['color', 'palette', 'purple', '500'],
  },
  {
    value: '#8110dc',
    name: 'colorPalettePurple600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '600',
    },
    path: ['color', 'palette', 'purple', '600'],
  },
  {
    value: '#7300d3',
    name: 'colorPalettePurple700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '700',
    },
    path: ['color', 'palette', 'purple', '700'],
  },
  {
    value: '#6500ce',
    name: 'colorPalettePurple800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '800',
    },
    path: ['color', 'palette', 'purple', '800'],
  },
  {
    value: '#4e00c6',
    name: 'colorPalettePurple900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'purple',
      subitem: '900',
    },
    path: ['color', 'palette', 'purple', '900'],
  },
  {
    value: '#f5e9e8',
    name: 'colorPaletteRed50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '50',
    },
    path: ['color', 'palette', 'red', '50'],
  },
  {
    value: '#f4cfcd',
    name: 'colorPaletteRed100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '100',
    },
    path: ['color', 'palette', 'red', '100'],
  },
  {
    value: '#eca9a5',
    name: 'colorPaletteRed200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '200',
    },
    path: ['color', 'palette', 'red', '200'],
  },
  {
    value: '#e3837d',
    name: 'colorPaletteRed300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '300',
    },
    path: ['color', 'palette', 'red', '300'],
  },
  {
    value: '#da5d55',
    name: 'colorPaletteRed400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '400',
    },
    path: ['color', 'palette', 'red', '400'],
  },
  {
    value: '#d44037',
    name: 'colorPaletteRed500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '500',
    },
    path: ['color', 'palette', 'red', '500'],
  },
  {
    value: '#b4362f',
    name: 'colorPaletteRed600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '600',
    },
    path: ['color', 'palette', 'red', '600'],
  },
  {
    value: '#942d27',
    name: 'colorPaletteRed700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '700',
    },
    path: ['color', 'palette', 'red', '700'],
  },
  {
    value: '#75231e',
    name: 'colorPaletteRed800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '800',
    },
    path: ['color', 'palette', 'red', '800'],
  },
  {
    value: '#551a16',
    name: 'colorPaletteRed900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'red',
      subitem: '900',
    },
    path: ['color', 'palette', 'red', '900'],
  },
  {
    value: '#fefae7',
    name: 'colorPaletteYellow50',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '50',
    },
    path: ['color', 'palette', 'yellow', '50'],
  },
  {
    value: '#fbf1c4',
    name: 'colorPaletteYellow100',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '100',
    },
    path: ['color', 'palette', 'yellow', '100'],
  },
  {
    value: '#f8e99f',
    name: 'colorPaletteYellow200',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '200',
    },
    path: ['color', 'palette', 'yellow', '200'],
  },
  {
    value: '#f4e07b',
    name: 'colorPaletteYellow300',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '300',
    },
    path: ['color', 'palette', 'yellow', '300'],
  },
  {
    value: '#f0d961',
    name: 'colorPaletteYellow400',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '400',
    },
    path: ['color', 'palette', 'yellow', '400'],
  },
  {
    value: '#ecd348',
    name: 'colorPaletteYellow500',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '500',
    },
    path: ['color', 'palette', 'yellow', '500'],
  },
  {
    value: '#dcc243',
    name: 'colorPaletteYellow600',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '600',
    },
    path: ['color', 'palette', 'yellow', '600'],
  },
  {
    value: '#c8ac3d',
    name: 'colorPaletteYellow700',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '700',
    },
    path: ['color', 'palette', 'yellow', '700'],
  },
  {
    value: '#b39638',
    name: 'colorPaletteYellow800',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '800',
    },
    path: ['color', 'palette', 'yellow', '800'],
  },
  {
    value: '#90722f',
    name: 'colorPaletteYellow900',
    attributes: {
      category: 'color',
      type: 'palette',
      item: 'yellow',
      subitem: '900',
    },
    path: ['color', 'palette', 'yellow', '900'],
  },
  {
    value: '#3142c8',
    name: 'colorPrimaryDefault',
    attributes: {
      category: 'color',
      type: 'primary',
      item: 'default',
    },
    path: ['color', 'primary', 'default'],
  },
  {
    value: '#16158d',
    name: 'colorPrimaryActive',
    attributes: {
      category: 'color',
      type: 'primary',
      item: 'active',
    },
    path: ['color', 'primary', 'active'],
  },
  {
    value: '#2e39ad',
    name: 'colorPrimaryHover',
    attributes: {
      category: 'color',
      type: 'primary',
      item: 'hover',
    },
    path: ['color', 'primary', 'hover'],
  },
  {
    value: '#ffffff',
    name: 'colorTextContrast',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'contrast',
    },
    path: ['color', 'text', 'contrast'],
  },
  {
    value: '#b4362f',
    name: 'colorTextDanger',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'danger',
    },
    path: ['color', 'text', 'danger'],
  },
  {
    value: '#a9adb1',
    name: 'colorTextDisabled',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'disabled',
    },
    path: ['color', 'text', 'disabled'],
  },
  {
    value: '#091521',
    name: 'colorTextPrimary',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'primary',
    },
    path: ['color', 'text', 'primary'],
  },
  {
    value: '#49515a',
    name: 'colorTextSecondary',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'secondary',
    },
    path: ['color', 'text', 'secondary'],
  },
  {
    value: '#0b6b3d',
    name: 'colorTextSuccess',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'success',
    },
    path: ['color', 'text', 'success'],
  },
  {
    value: '#898e94',
    name: 'colorTextTertiary',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'tertiary',
    },
    path: ['color', 'text', 'tertiary'],
  },
  {
    value: '#f45e1e',
    name: 'colorTextWarning',
    attributes: {
      category: 'color',
      type: 'text',
      item: 'warning',
    },
    path: ['color', 'text', 'warning'],
  },
  {
    value: '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 6px 14px rgba(61, 58, 180, 0.15)',
    name: 'shadowLarge',
    attributes: {
      category: 'shadow',
      type: 'large',
    },
    path: ['shadow', 'large'],
  },
  {
    value: '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 4px 5px rgba(61, 58, 180, 0.15)',
    name: 'shadowMedium',
    attributes: {
      category: 'shadow',
      type: 'medium',
    },
    path: ['shadow', 'medium'],
  },
  {
    value: '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 1px 2px rgba(61, 58, 180, 0.4)',
    name: 'shadowSmall',
    attributes: {
      category: 'shadow',
      type: 'small',
    },
    path: ['shadow', 'small'],
  },
  {
    value: 6000,
    name: 'zIndexDialog',
    attributes: {
      category: 'zIndex',
      type: 'dialog',
    },
    path: ['zIndex', 'dialog'],
  },
  {
    value: 7000,
    name: 'zIndexDropdown',
    attributes: {
      category: 'zIndex',
      type: 'dropdown',
    },
    path: ['zIndex', 'dropdown'],
  },
  {
    value: 9000,
    name: 'zIndexModal',
    attributes: {
      category: 'zIndex',
      type: 'modal',
    },
    path: ['zIndex', 'modal'],
  },
  {
    value: 8000,
    name: 'zIndexOverlay',
    attributes: {
      category: 'zIndex',
      type: 'overlay',
    },
    path: ['zIndex', 'overlay'],
  },
  {
    value: 5000,
    name: 'zIndexPopover',
    attributes: {
      category: 'zIndex',
      type: 'popover',
    },
    path: ['zIndex', 'popover'],
  },
  {
    value: 100,
    name: 'zIndexSticky',
    attributes: {
      category: 'zIndex',
      type: 'sticky',
    },
    path: ['zIndex', 'sticky'],
  },
  {
    value: 10000,
    name: 'zIndexToast',
    attributes: {
      category: 'zIndex',
      type: 'toast',
    },
    path: ['zIndex', 'toast'],
  },
  {
    value: 6000,
    name: 'zIndexTooltip',
    attributes: {
      category: 'zIndex',
      type: 'tooltip',
    },
    path: ['zIndex', 'tooltip'],
  },
  {
    value: '87.5rem',
    name: 'sizeLarge',
    attributes: {
      category: 'size',
      type: 'large',
    },
    path: ['size', 'large'],
  },
  {
    value: '80rem',
    name: 'sizeMedium',
    attributes: {
      category: 'size',
      type: 'medium',
    },
    path: ['size', 'medium'],
  },
  {
    value: '60rem',
    name: 'sizeSmall',
    attributes: {
      category: 'size',
      type: 'small',
    },
    path: ['size', 'small'],
  },
  {
    value: '120rem',
    name: 'sizeXLarge',
    attributes: {
      category: 'size',
      type: 'x-large',
    },
    path: ['size', 'x-large'],
  },
  {
    value: '40.625rem',
    name: 'sizeXSmall',
    attributes: {
      category: 'size',
      type: 'x-small',
    },
    path: ['size', 'x-small'],
  },
  {
    value: '1rem',
    name: 'spaceMedium',
    attributes: {
      category: 'space',
      type: 'medium',
    },
    path: ['space', 'medium'],
  },
  {
    value: '0.5rem',
    name: 'spaceSmall',
    attributes: {
      category: 'space',
      type: 'small',
    },
    path: ['space', 'small'],
  },
  {
    value: '1.5rem',
    name: 'spaceLarge',
    attributes: {
      category: 'space',
      type: 'large',
    },
    path: ['space', 'large'],
  },
  {
    value: '2rem',
    name: 'spaceXLarge',
    attributes: {
      category: 'space',
      type: 'x-large',
    },
    path: ['space', 'x-large'],
  },
  {
    value: '0.25rem',
    name: 'spaceXSmall',
    attributes: {
      category: 'space',
      type: 'x-small',
    },
    path: ['space', 'x-small'],
  },
  {
    value: '"Fira Mono", Courier, monospace',
    name: 'fontFamilyMono',
    attributes: {
      category: 'fontFamily',
      type: 'mono',
    },
    path: ['fontFamily', 'mono'],
  },
  {
    value:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
    name: 'fontFamilyText',
    attributes: {
      category: 'fontFamily',
      type: 'text',
    },
    path: ['fontFamily', 'text'],
  },
  {
    value: '1.25rem',
    name: 'fontSizeLarge',
    attributes: {
      category: 'fontSize',
      type: 'large',
    },
    path: ['fontSize', 'large'],
  },
  {
    value: '1rem',
    name: 'fontSizeMedium',
    attributes: {
      category: 'fontSize',
      type: 'medium',
    },
    path: ['fontSize', 'medium'],
  },
  {
    value: '0.875rem',
    name: 'fontSizeSmall',
    attributes: {
      category: 'fontSize',
      type: 'small',
    },
    path: ['fontSize', 'small'],
  },
  {
    value: '1.5rem',
    name: 'fontSizeXLarge',
    attributes: {
      category: 'fontSize',
      type: 'x-large',
    },
    path: ['fontSize', 'x-large'],
  },
  {
    value: '0.75rem',
    name: 'fontSizeXSmall',
    attributes: {
      category: 'fontSize',
      type: 'x-small',
    },
    path: ['fontSize', 'x-small'],
  },
  {
    value: '2rem',
    name: 'fontSizeXxLarge',
    attributes: {
      category: 'fontSize',
      type: 'xx-large',
    },
    path: ['fontSize', 'xx-large'],
  },
  {
    value: 700,
    name: 'fontWeightBold',
    attributes: {
      category: 'fontWeight',
      type: 'bold',
    },
    path: ['fontWeight', 'bold'],
  },
  {
    value: 400,
    name: 'fontWeightRegular',
    attributes: {
      category: 'fontWeight',
      type: 'regular',
    },
    path: ['fontWeight', 'regular'],
  },
  {
    value: 600,
    name: 'fontWeightSemibold',
    attributes: {
      category: 'fontWeight',
      type: 'semibold',
    },
    path: ['fontWeight', 'semibold'],
  },
  {
    value: '0em',
    name: 'letterSpacingLarge',
    attributes: {
      category: 'letterSpacing',
      type: 'large',
    },
    path: ['letterSpacing', 'large'],
  },
  {
    value: '-0.01em',
    name: 'letterSpacingMedium',
    attributes: {
      category: 'letterSpacing',
      type: 'medium',
    },
    path: ['letterSpacing', 'medium'],
  },
  {
    value: '-0.02em',
    name: 'letterSpacingSmall',
    attributes: {
      category: 'letterSpacing',
      type: 'small',
    },
    path: ['letterSpacing', 'small'],
  },
  {
    value: '-0.03em',
    name: 'letterSpacingXSmall',
    attributes: {
      category: 'letterSpacing',
      type: 'x-small',
    },
    path: ['letterSpacing', 'x-small'],
  },
  {
    value: '1.875rem',
    name: 'lineHeightLarge',
    attributes: {
      category: 'lineHeight',
      type: 'large',
    },
    path: ['lineHeight', 'large'],
  },
  {
    value: '1.5rem',
    name: 'lineHeightMedium',
    attributes: {
      category: 'lineHeight',
      type: 'medium',
    },
    path: ['lineHeight', 'medium'],
  },
  {
    value: '1.25rem',
    name: 'lineHeightSmall',
    attributes: {
      category: 'lineHeight',
      type: 'small',
    },
    path: ['lineHeight', 'small'],
  },
  {
    value: '2rem',
    name: 'lineHeightXLarge',
    attributes: {
      category: 'lineHeight',
      type: 'x-large',
    },
    path: ['lineHeight', 'x-large'],
  },
  {
    value: '1.125rem',
    name: 'lineHeightXSmall',
    attributes: {
      category: 'lineHeight',
      type: 'x-small',
    },
    path: ['lineHeight', 'x-small'],
  },
  {
    value: '2.625rem',
    name: 'lineHeightXxLarge',
    attributes: {
      category: 'lineHeight',
      type: 'xx-large',
    },
    path: ['lineHeight', 'xx-large'],
  },
];
